module.exports = __webpack_public_path__ + "static/media/outsite-form-bg@2x.5d208002.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/outsite-form-bg@2x.png
// module id = 1022
// module chunks = 0